import { Component, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MeterGroupComponent } from '../meter-group/meter-group.component';
import { PortfolioDetail } from '../../../../data-access/models/portfolio-detail.model';
import { MetersPipe } from '../../pipes/meters.pipe';

@Component({
  selector: 'app-portfo-assets',
  standalone: true,
  imports: [DecimalPipe, MeterGroupComponent, MetersPipe],
  templateUrl: './portfo-assets.component.html',
  styleUrl: './portfo-assets.component.scss',
})
export class PortfoAssetsComponent {
  assets = input<{
    balance: number;
    portfolioDetails: PortfolioDetail[];
  }>();
  canSee = input.required<boolean>();
}
